import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { GeneralRoutePaths } from '../../enums/route-types.enum';
import { PermissionsService } from '../../services/permissions/permissions.service';

export const userAdminGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const permissionsService = inject(PermissionsService);

  return permissionsService.hasUserAdminPermission() ? true : router.createUrlTree([GeneralRoutePaths.PAGE_NOT_FOUND]);
};
